import React, { useEffect, useState } from "react";
import { Alert, Avatar, Box, Button, Card, CardContent, Container, Divider, Grid, Grid2, Modal, Snackbar, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from "@mui/material";
import Layout from "./Layout";
import GroupIcon from '@mui/icons-material/Group';
import LeadsImg from '../images/Leads.png'
import EligibleLeadsImg from '../images/Eligible.png'
import IneligibleLeadsImg from '../images/Ineligible.png'
import AssignedImg from '../images/Assigned2.png'
import { DataGrid, GridToolbar, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import { DropzoneDialog } from "mui-file-dropzone";
import uploadCompletedImg from '../images/UploadCompleted.png'
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../helpers/formatter";
import moment from "moment";
import { getAllLeads, triggerLink } from "../actions/leadsAction";
import { leadStatus } from "../helpers/status";
import { pathOr } from "ramda";
import { useNavigate } from "react-router";


const Leads = () => {
    const { leads } = useSelector(state => state.Leads)
     const [snack, setsnack] = React.useState(false);
     const [snackMessage, setsnackMessage] = React.useState('');
     const [snackState, setsnackState] = React.useState('success');
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(()=>{
    dispatch(getAllLeads())
},[]);
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }



  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          size="small"
          style={{ marginLeft: 16, background: '#4DA235', color: '#fff' }}
          onClick={() => {
              dispatch(triggerLink({ policyId: params.row.id })).then((data) => {
                  if (pathOr('', ['status'], data) == 'success') {
                        setsnackState('success')
                        setsnackMessage('Message sent successfully');
                        setsnack(true);
                  } else {
                      setsnackState('error')
                        setsnackMessage('Could not send message, please try after sometime');
                        setsnack(true);
                  }
                  
              })
              
          }}
        >
          Send SMS
        </Button>
        <Button
          variant="contained"
          size="small"
          style={{ marginLeft: 16, background: '#4DA235', color: '#fff' }}
          onClick={() => {
            navigate('/viewleads/'+params.row.id)
              
          }}
        >
          VIEW LEAD
        </Button>
      </strong>
    )
  }
  const eligibleLeads = []
  const inEligibleLeads = []
  leads.forEach((l, i) => {
    if (l.isAssignmentEligible) {
      eligibleLeads.push({
        id: l._id,
        createdOn: moment(l.createdAt).format("DD-MM-YYYY"),
        firstName: l.policyHolderName,
        policyNumber: l.policyNumber,
        surrenderValue: `₹ ${formatCurrency(l.surrenderValue)}`,
        leadStatus: leadStatus(l)
      })
    }
  })

  leads.forEach((l, i) => {
    if (!l.isAssignmentEligible) {
      inEligibleLeads.push({
        id: i,
        createdOn: moment(l.createdAt).format("DD-MM-YYYY"),
        firstName: l.policyHolderName,
        policyNumber: l.policyNumber,
        surrenderValue: `₹ ${formatCurrency(l.surrenderValue)}`,
        leadStatus: 'New Lead'
      })
    }
  })



  const rows = [
    { id: 1, createdOn: '20/11/2024', firstName: 'Sunil Chuhan', policyNumber: "4620074", surrenderValue: '₹ 2,49,876', leadStatus: 'New Lead' },
    { id: 2, createdOn: '20/11/2024', firstName: 'Sunil Chuhan', policyNumber: "4620074", surrenderValue: '₹ 2,49,876', leadStatus: 'New Lead' },
    { id: 3, createdOn: '20/11/2024', firstName: 'Sunil Chuhan', policyNumber: "4620074", surrenderValue: '₹ 2,49,876', leadStatus: 'New Lead' },
    { id: 4, createdOn: '20/11/2024', firstName: 'Sunil Chuhan', policyNumber: "4620074", surrenderValue: '₹ 2,49,876', leadStatus: 'New Lead' },
    { id: 5, createdOn: '20/11/2024', firstName: 'Sunil Chuhan', policyNumber: "4620074", surrenderValue: '₹ 2,49,876', leadStatus: 'New Lead' },
  ];

  const columns: GridColDef[] = [
    { field: 'createdOn', headerName: 'Date', width: 150 },
    { field: 'firstName', headerName: 'Name', width: 150 },
    { field: 'policyNumber', headerName: 'Policy Number', width: 150 },
    { field: 'surrenderValue', headerName: 'Surrender Value', width: 150 },
    { field: 'leadStatus', headerName: 'Status', width: 150 },
    { field: 'action', type: 'actions', headerName: 'Action', renderCell: renderDetailsButton, width: 250 },
  ];
  const incolumns: GridColDef[] = [
    { field: 'createdOn', headerName: 'Date', width: 150 },
    { field: 'firstName', headerName: 'Name', width: 150 },
    { field: 'policyNumber', headerName: 'Policy Number', width: 150 },
    { field: 'surrenderValue', headerName: 'Surrender Value', width: 150 },
    // { field: 'leadStatus', headerName: 'Status', width: 150 },
    // { field: 'action', type: 'actions', headerName: 'Action', renderCell: renderDetailsButton, width: 150 },
  ];



  return (
    <>
      <Layout>
        <React.Fragment>
          <Container>
            <Grid2 container alignItems={"center"} justifyContent={'space-between'}>
              <Grid2 item>
                <Typography variant="h4" mt={2} mb={2}>{"Policy Assignment Leads"}</Typography>
              </Grid2>
              <Grid2 item>
                <Button variant="outlined" sx={{ background: '#4DA235', color: '#fff'  }} >Add Bulk Leads</Button>
                {/* <Button sx={{ marginLeft: 4, background: '#4DA235', color: '#fff' }} variant="contained">Add Lead</Button> */}
              </Grid2>
            </Grid2>

            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Eligible Leads" {...a11yProps(0)} />
                  <Tab label="Ineligible Leads" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <Paper>
                                  <DataGrid rows={eligibleLeads} columns={columns} slots={{ toolbar: GridToolbar }}
                                  slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
                                  />
                </Paper>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Paper sx={{width:700}}>
                  <DataGrid  rows={inEligibleLeads} columns={incolumns} slots={{ toolbar: GridToolbar }} />
                </Paper>
              </CustomTabPanel>
            </Box>

<Snackbar open={snack} autoHideDuration={6000} onClose={()=>{setsnack(false)}}>
                          <Alert
                               anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={()=>{setsnack(false)}}
          severity={snackState}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>

          </Container>
        </React.Fragment>
      </Layout>
    </>
  )
}

export default Leads